<template>
  <div class="drawing-toolbar" v-show="isVisible">
    <div class="toolbar-title">
      <i class="el-icon-edit"></i>
      绘制工具
    </div>
    
    <div class="toolbar-buttons">
      <!-- 撤销上一个点 -->
      <el-tooltip content="撤销上一个点" placement="left">
        <el-button 
          size="mini"
          icon="el-icon-back"
          circle
          :disabled="!canUndo"
          @click="$emit('undo')">
        </el-button>
      </el-tooltip>
      
      <!-- 重做（恢复被撤销的点） -->
      <el-tooltip content="恢复上一个点" placement="left">
        <el-button 
          size="mini"
          icon="el-icon-right"
          circle
          :disabled="!canRedo"
          @click="$emit('redo')">
        </el-button>
      </el-tooltip>
      
      <!-- 清除全部绘制内容 -->
      <el-tooltip content="清除所有点" placement="left">
        <el-button 
          size="mini"
          icon="el-icon-delete"
          circle
          :disabled="!hasPoints"
          @click="$emit('clear')">
        </el-button>
      </el-tooltip>
      
      <!-- 完成绘制 -->
      <el-tooltip content="完成绘制" placement="left">
        <el-button 
          size="mini"
          type="primary"
          icon="el-icon-check"
          circle
          :disabled="!canFinish"
          @click="$emit('finish')">
        </el-button>
      </el-tooltip>
    </div>
    
    <div class="points-info">
      <small>已绘制: {{ pointsCount }}个点</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DrawingToolbar',
  props: {
    // 是否显示绘制工具栏
    isVisible: {
      type: Boolean,
      default: false
    },
    // 当前绘制的点数量
    pointsCount: {
      type: Number,
      default: 0
    },
    // 历史点的数量（用于恢复操作）
    historyPointsCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // 是否可以撤销操作
    canUndo() {
      return this.pointsCount > 0;
    },
    // 是否可以重做操作
    canRedo() {
      return this.historyPointsCount > 0;
    },
    // 是否有绘制的点
    hasPoints() {
      return this.pointsCount > 0;
    },
    // 是否可以完成绘制（至少2个点即可完成）
    canFinish() {
      return this.pointsCount >= 2;
    }
  }
};
</script>

<style scoped>
.drawing-toolbar {
  position: absolute;
  top: 80px;
  right: 15px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 8px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 120px;
}

.toolbar-title {
  font-size: 13px;
  font-weight: bold;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.toolbar-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.points-info {
  font-size: 12px;
  color: #909399;
  text-align: center;
  margin-top: 5px;
}
</style> 